import { useState, useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useParams } from 'react-router-dom';

// Custom Component
import ErrorAlert from '../../components/Alert/ErrorAlert';
import PaymentPendingModal from "../../components/Modal/PaymentPendingModal";

// API Service
import { teamPlayerService } from '../../service/tournament.service';

const PaymentPending = () => {
    let { tournamentId, teamId } = useParams();

    const [tournament, setTournament] = useState();
    const [paymentPendingModal, setPaymentPendingModal] = useState(false)

    /**
        * @function fetchCustomerSingleTournament
        * @params
        * @description fetch the single tournament details for customer
    */
    const fetchCustomerSingleTournament = async () => {
        try {
            const result = await teamPlayerService({
                id: tournamentId,
                teamId
            });
            if (result?.data?.status) {
                setTournament(result?.data?.data)
                handlePaymentPendingModal()
            } else {
                ErrorAlert(result?.response?.data?.message)
            }
        } catch (error) {
            ErrorAlert(error)
        }
    }

    useEffect(() => {
        fetchCustomerSingleTournament()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tournamentId])

    /**
        * @function handlePaymentPendingModal
        * @params
        * @description set the visibility of payment pending modal
    */
    const handlePaymentPendingModal = () => {
        setPaymentPendingModal(!paymentPendingModal)
    }

    return <HelmetProvider>
        <Helmet prioritizeSeoTags>
            <title>Payment Failure | AFA Tournament - Your Gateway to Sporting Excellence!</title>
        </Helmet>

        {/* Payment Pending Modal */}
        <PaymentPendingModal
            show={paymentPendingModal}
            handleClose={handlePaymentPendingModal}
            tournament={tournament}
            size='lg'
        />
    </HelmetProvider>
};

export default PaymentPending;